import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { ZefForm, ZefFormsManagerService } from '@zerops/zef/forms';
import { AppState } from '@zerops/zerops/app';
import { FormState } from 'ngrx-forms';
import { FEATURE_GITLAB_FORM } from './remote-repository-connector.constant';

export interface RemoteRepositoryConnectorGitlabFormValue {
  repositoryFullName: string;
  isActive: boolean;
  eventType: 'BRANCH' | 'TAG';
  branchName?: string;
  triggerBuild: boolean;
  zeropsYamlSetup?: string;
  tagRegex?: string;
}

export type ReadyToDeployGithubFormState = FormState<RemoteRepositoryConnectorGitlabFormValue>;

@Injectable({ providedIn: 'root' })
export class RemoteRepositoryConnectorGitlabForm extends ZefForm<RemoteRepositoryConnectorGitlabFormValue> {
  constructor(
    public store: Store<AppState>,
    public formsManager: ZefFormsManagerService
  ) {
    super(
      store,
      formsManager,
      FEATURE_GITLAB_FORM,
      {
        repositoryFullName: undefined,
        isActive: true,
        eventType: 'TAG',
        branchName: undefined,
        zeropsYamlSetup: undefined,
        triggerBuild: false,
        tagRegex: undefined
      },
      {}
    );
  }
}
